import { useEffect, useMemo } from "react";

// JSON-LD helper.
// Renders a <script type="application/ld+json"> element into <head> without
// ever using dangerouslySetInnerHTML. Data is a controlled JS object; we set
// it via `script.textContent`, which the browser treats as script raw text
// (no HTML parsing, no XSS surface).
export default function JsonLd({ data }) {
  // Memoise the serialised payload so we don't rebuild every render.
  const json = useMemo(() => JSON.stringify(data), [data]);

  useEffect(() => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.textContent = json; // safe: raw-text node, not HTML
    document.head.appendChild(el);
    return () => {
      if (el.parentNode) el.parentNode.removeChild(el);
    };
  }, [json]);

  return null;
}
